(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-sold-table', [
    'pp.widgets-templates',
    'pp.controllers.dashboard-table',
    'pp.components.table-sort',
    'pp.widgets.property-actions-dropdown'
]);

ngModule.component('ppDashboardSoldTable', {
    templateUrl: 'widgets/_angular/dashboard-sold-table/dashboard-sold-table.tpl.html',
    bindings: {
        data: '<',
        onChange: '&',
        sortAttribute: '<',
        openSidebarSymbol: '<',
        sortOrder: '<'
    },
    controllerAs: 'vm',
    controller: 'ppDashboardTableCtrl'
});
})(window, window.angular);